import React from 'react';

import SignInButton from '../../../components/buttons/SignInButton';
import { LandingSection, LandingSectionHeader, LandingTile, LandingTileGrid } from '../../components';
import { mcpExamples } from '../../content/mcpExamples';

function McpSection() {
  return <LandingSection id="mcp-server" className="landing-mcp-section">
    <LandingSectionHeader eyebrow="GoldAPI MCP Server" title="Use GoldAPI with your AI Agent" description="Give ChatGPT, Claude, Codex, and other MCP-compatible AI clients secure, structured tools for precious-metals prices, currency conversion, valuations, and analysis." />
    <LandingTileGrid className="landing-mcp-example-grid">
      {mcpExamples.map(example => <LandingTile className="landing-mcp-example-card" key={example.tool}>
        <div className="landing-mcp-example-label">Example prompt</div>
        <blockquote>“{example.prompt}”</blockquote>
        <div className="landing-mcp-tool"><span>Tool</span><code>{example.tool}</code></div>
        <div className="landing-mcp-response"><span>Example response</span><div className="landing-mcp-response-body">{example.response}</div></div>
      </LandingTile>)}
    </LandingTileGrid>
    <p className="landing-mcp-plan-note text-center text-muted">Available on the Business plan. Connect through OAuth or your GoldAPI key using the remote Streamable HTTP MCP endpoint.</p>
    <div className="landing-mcp-actions"><SignInButton /></div>
  </LandingSection>;
}

export default McpSection;
